import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Stores ?ref=<code> so registrations can be attributed to an influencer
export default function ReferralCapture() {
  const { search } = useLocation();
  useEffect(() => {
    const ref = new URLSearchParams(search).get('ref');
    if (ref) localStorage.setItem('trabadju_ref', ref.trim().toLowerCase().slice(0, 32));
  }, [search]);
  return null;
}
